// src/components/ImageCropperModal.jsx
import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import "../ImageCropperModel/ImageCropperModel.css";
import { getCroppedImg } from "../../utils/cropImage";

const ImageCropperModal = ({ imageSrc, onCancel, onSave }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = useCallback((croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  // const handleSave = async () => {
  //   const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
  //   onSave(croppedImage);
  // };

  // src/components/ImageCropperModal.jsx
  const handleSave = async () => {
    console.log("Saving cropped image...");
    console.log("Current croppedAreaPixels:", croppedAreaPixels);

    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    console.log(
      "Cropped image result:",
      typeof croppedImage,
      croppedImage.substring(0, 100)
    );

    onSave(croppedImage);
  };

  return (
    <div className="cropper-modal">
      <div className="cropper-content">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={1} // square
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
        <div className="controls">
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(e.target.value)}
          />
          <div className="buttons">
            <button onClick={onCancel}>Cancel</button>
            <button onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCropperModal;
